import {isNilOrEmpty} from 'ramda-adjunct';

import {useSetAdditionalNoteMutation} from '@dms/api/sales';
import {handleApiError} from '@dms/shared';

/**
 * Custom hook for managing additional note state and saving functionality.
 *
 * Provides handlers for saving note for a vehicle
 *
 * @returns An object containing:
 *   - handleSaveNote: Function to save note for a vehicle
 *   - isSaveLoading: Boolean indicating if save is in progress
 */
export function useAdditionalNote() {
  const [saveNote, {isLoading: isSaveLoading}] = useSetAdditionalNoteMutation();

  const handleSaveNote = (vehicleId: string, note: string) => {
    if (isNilOrEmpty(vehicleId)) {
      return;
    }
    return saveNote({
      vehicleId,
      additionalNoteRequestBody: {
        note,
      },
    })
      .unwrap()
      .catch(handleApiError);
  };

  return {
    handleSaveNote,
    isSaveLoading,
  };
}
